import clsx from "clsx";
import { Button, ButtonProps } from "../button";

export interface OhButtonProps extends Omit<ButtonProps, "variant"> {
  variant?: "primary" | "secondary" | "tertiary" | "destructive";
}

const variantClasses = {
  primary: "bg-oh-primary hover:bg-oh-dark-primary text-white",
  secondary: "bg-black text-white",
  tertiary: "border bg-gray-50 border-gray-300 text-gray-800 hover:bg-gray-100",
  destructive: "bg-oh-secondary hover:bg-oh-dark-secondary text-white",
} as const;

export function OhButton({ variant = "primary", className, ...props }: OhButtonProps) {
  return (
    <Button
      className={clsx(
        variantClasses[variant],
        className,
      )}
      {...props}
    />
  );
}